module.exports = __webpack_public_path__ + "static/7-download-extension-474ede896eb00b8a855e941844f5961f.jpg";